<div class="col-12" aria-labelledby="advance-search"
  [ngClass]="{'flex-column':isNewLine, 'px-1':!customCol, 'pl-0':(viewLocation==='acmt-search' && customCol), 'align-items-center':!isNewLine, 'd-flex-block':isTreeSearch, 'd-flex':!isTreeSearch}">
  <div class="p-0 pr-1" *ngIf="showLabel"
    [ngClass]="viewLocation==='acmt-search'?'col-3 col-xl-2': (isTreeSearch ? 'col-12' : 'col-auto')">
    <p class="m-0 font-bold" id="{{'dropdownlabel'+id}}">{{label | titlecase}}
      <span class="mandatory" *ngIf="isMandatory">*</span>
    </p>
  </div>
  <div class="px-0"
    [ngClass]="viewLocation==='acmt-search'? (customCol?'col-12':'col-9 col-xl-10') : (isTreeSearch ? 'col-12':'col')">
    <div class="show" (clickOutside)="onClickOutSide()" [attr.class]="viewLocation==='profile'?'dropdown':'dropdown'">
      <ng-container>
        <div class="d-flex align-items-center justify-content-start w-100"
          [ngClass]="{'mr-2': (viewLocation===SEARCH_LOCATION), 'ml-1': (viewLocation===DATATABLE_LOCATION)}">

          <button type="button" *ngIf="buttonType==='button'" [attr.aria-expanded]="showDropdown" aria-haspopup="true"
            class="cursor-pointer custom-select select-node d-inline-flex"
            [ngClass]="viewLocation==='acmt-search'?'lg-custom-select':''" id="{{'btn'+id}}"
            [attr.aria-describedby]="'dropdownlabel'+id" title="{{selectedData[uniqueProp]}}"
            (mousedown)="$event.stopPropagation()" (click)="toggleDropdown();">
            <span class="trimmed text-truncate">
              {{selectedData[uniqueProp]}}
            </span>
          </button>

          <button type="button" *ngIf="buttonType==='icon'" [attr.aria-expanded]="showDropdown" aria-haspopup="true"
            data-display="static" class="btn btn-icon btn-filter filter tooltip top position-relative"
            [attr.aria-label]="'filter by '+ label" data-tooltip="Filter" id="{{'btn'+id}}" (click)="toggleDropdown();">
            <em class="material-icons-outlined button-icon" aria-hidden="true">filter_alt</em>
          </button>

          <button class="btn btn-sm btn-icon px-1 py-0 mt-1" id="pluscircleBtn" *ngIf="buttonType==='plusCircle'"
            (click)="toggleDropdown()" aria-label="Add">
            <em class="material-icons-outlined font-4x" aria-hidden="true">add_circle</em>
          </button>
        </div>

        <div [attr.aria-labelledby]="'btn'+id" class="dropdown-menu px-0 pt-0" id="{{'dropdownpanel'+id}}"
          [ngClass]="[showDropdown ? 'show':'' ,isAllselect ? 'lang-selector':'', lastIndex?'dropdown-menu-right' :'dropdown-menu-left']"
          (mousedown)="$event.stopPropagation()">

          <div class="col-12 p-0">
            <span class="search-icon position-absolute">
              <em class="material-icons-outlined font-5x mt-1" aria-hidden="true">search</em>
            </span>
            <label for="{{id+'searchBox'}}" class="sr-only">Search</label>
            <input type="search" placeholder="Search" autocomplete="off" [(ngModel)]="searchKeyword"
              class="form-control search-inputfield position-relative" id="{{id+'searchBox'}}"
              (keyup)="onSearch(uniqueProp)">
            <button type="button" class="cursor-pointer search-clear p-0 position-absolute" id="onclearsearchtextBtn"
              aria-label="Clear search" (click)="onClearSearchText()" [hidden]="searchKeyword?.length<1"
              [disabled]="searchKeyword?.length<1">&times;</button>
              <p *ngIf="searchTextClear" id="alert" class="sr-only" role="alert">Search text is cleared</p>
          </div>

          <div class="col-12 p-2 search__options d-flex justify-content-between align-items-center mb-2"
            *ngIf="data && data.length > 0">
            <div class="col-auto p-0">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="{{'selectall'+id}}" class="custom-control-input" [checked]="isAllSelected"
                  (click)="doCheckBoxesSelection(!isAllSelected)">
                <label for="{{'selectall'+id}}" id="{{'selectallLabel'+id}}" class="custom-control-label d-flex">
                  <span class="trimmed text-truncate">{{isAllSelected ? 'Deselect' : 'Select'}} All</span>
                </label>
              </div>
            </div>
              <div class="d-flex">
                <div>
                  <button type="button" [disabled]="selectedDataList.length === 0" id="{{'clear'+id}}" class="btn btn-cancel btn-sm text-underline"
                    (click)="clearAllSelect();addSelection(true);">Clear</button>
                </div>
                <div>
                  <button type="button" id="{{'select'+id}}" class="btn btn-primary btn-sm"
                    (click)="addSelection(true)">Apply</button>
                </div>
              </div>
          </div>

          <div class="dropdown-overflow px-2">
            <ng-container *ngIf="data && data.length < 1">
              <p class="pt-2 px-2 mb-0" role="alert"><span class="sr-only">Error</span> No records found</p>
            </ng-container>
            <ng-container *ngIf="data && data.length > 0">
              <ul class="list-inline mb-0">
                <li class="list-inline-item custom-control custom-checkbox mb-1"
                  *ngFor="let option of data;let index=index;">
                  <input type="checkbox" [checked]="option?.is_selected===1" class="custom-control-input"
                    id="{{option[uniqueProp].split(' ').join('')+index}}"
                    [attr.id]="option[uniqueProp]?.split(' ').join('-')+'-'+index+'_'+id"
                    (click)="onOptionSelect(option)">
                  <label class="custom-control-label d-flex"
                    id="{{option[uniqueProp].split(' ').join('')+'label'+index}}"
                    for="{{option[uniqueProp]?.split(' ').join('-')+'-'+index+'_'+id}}">
                    <span class="text-truncate">{{option.colName == 'state' ? option[uniqueProp] == 1 ? 'Archive' : 'Active' : option[uniqueProp]}}</span>
                  </label>
                </li>
              </ul>
            </ng-container>
          </div>

        </div>
      </ng-container>
    </div>
  </div>
</div>
